import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// The availability email dialog on a group page (TMS-1784): behind Publish on
// a draft with a virtual offering, and on a published group's Settings tab.
// Picking who gets the email shows that choice's notes (who is skipped and
// why) and keeps the send button off while it would reach nobody; the
// preview is emailed to the admin without leaving the dialog.
export default class extends Controller {
  static targets = ["modal", "note", "sendButton", "submitButton", "previewButton", "previewStatus"];
  static values = { previewUrl: String };

  open(event) {
    event.preventDefault();

    Modal.getOrCreateInstance(this.modalTarget).show();
    this.modalTarget.addEventListener("shown.bs.modal", () => this.checkedAudience?.focus(), { once: true });
  }

  choose(event) {
    const audience = event.target.value;

    this.noteTargets.forEach((note) => {
      note.hidden = note.dataset.audience !== audience;
    });
    this.sendButtonTargets.forEach((button) => {
      button.disabled = Number(event.target.dataset.deliverable) === 0;
    });
  }

  // Disabled a tick later: a button disabled during the submit event is left
  // out of the form data, and which button was pressed is what says whether
  // to send.
  submit() {
    setTimeout(() => {
      this.submitButtonTargets.forEach((button) => {
        button.disabled = true;
      });
    }, 0);
  }

  async preview(event) {
    event.preventDefault();

    this.previewButtonTarget.disabled = true;
    this.previewStatusTarget.textContent = "Sending…";

    try {
      const response = await fetch(this.previewUrlValue, {
        method: "POST",
        headers: { Accept: "application/json", "X-CSRF-Token": this.csrfToken() },
      });
      const data = await response.json();
      this.previewStatusTarget.textContent = data.success
        ? `Sent to ${data.email}`
        : (data.errors || []).join(" ") || "Couldn't send the preview. Try again.";
    } catch {
      this.previewStatusTarget.textContent = "Couldn't send the preview. Try again.";
    } finally {
      this.previewButtonTarget.disabled = false;
    }
  }

  get checkedAudience() {
    return this.modalTarget.querySelector("input[name='availability_email[audience]']:checked");
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content;
  }
}
